import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { Translation } from '../../contexts/TranslationContext'
import type { BrandVisualResult } from '../../data/BrandFragment'
import { BrandCard } from './BrandCard'
import style from './BrandCardGroup.module.sass'

type BrandCardGroupProps = {
	title?: string
	brands: BrandVisualResult[]
	isBrandNameVisible?: boolean
	closeModal?: () => void
}

export const BrandCardGroup: FunctionComponent<BrandCardGroupProps> = ({
	brands,
	title,
	isBrandNameVisible = false,
	closeModal,
}) => {
	return (
		<div className={style.root}>
			{title && (
				<h2 className={style.title}>
					<Translation tr={title} />
				</h2>
			)}
			<div className={clsx(style.cardGroupWrapper, isBrandNameVisible && style.cardGroupWrapperWithBrand)}>
				{brands.map((brand) => (
					<div className={style.cardWrapper} key={brand.id}>
						<BrandCard brand={brand} isBrandNameVisible={isBrandNameVisible} closeModal={closeModal} />
					</div>
				))}
			</div>
		</div>
	)
}
